import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Results Driven Marketing",
  "Predictable New Patients",
  "Undeniable ROI",
  "Google · Meta · SEO",
  "Built For Dentists",
  "Full-Funnel Systems",
];

export default function LogoMarquee() {
  return (
    <section className="py-10 md:py-14 border-y border-white/5 bg-white/[0.015]">
      <div className="marquee-mask">
        <Marquee gradient={false} speed={18} pauseOnHover>
          {items.concat(items).map((t, i) => (
            <div
              key={i}
              className="flex items-center gap-6 mx-8 text-white/40 font-display text-2xl md:text-3xl tracking-tight"
            >
              <span>{t}</span>
              <span className="text-amber-400/70">✳</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
